import { useEffect } from 'react';
import { useDelight } from '../../contexts/DelightContext';
import { useLearner } from '../../hooks/useLearner';
import audioManager from '../../lib/audioManager';
import XPRewardModal from './XPRewardModal';
import CompactToast from './CompactToast';
import LevelUpCelebration from './LevelUpCelebration';

export default function DelightLayer() {
  const { current, dismiss } = useDelight();
  const { data: activeLearner } = useLearner();

  // Fire the appropriate cue once per presented delight item (audio-system.md):
  //   level-up fanfare for the celebration; xp-gain + modal-chime for the XP
  //   modal; xp-gain for a toast. Keyed on the item's stable _delightId so it
  //   fires exactly once per distinct XP event.
  useEffect(() => {
    if (!current) return;
    if (current.display_variant === 'celebration') {
      audioManager.playSFX('level-up');
    } else if (current.display_variant === 'modal') {
      audioManager.playSFX('modal-chime');
      audioManager.playSFX('xp-gain');
    } else if (current.display_variant === 'toast') {
      audioManager.playSFX('xp-gain');
    }
  }, [current?._delightId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!current) return null;

  if (current.display_variant === 'celebration') {
    return <LevelUpCelebration progression={current} onDismiss={dismiss} buddySlug={activeLearner?.buddy?.slug} />;
  }

  if (current.display_variant === 'modal') {
    return <XPRewardModal progression={current} onDismiss={dismiss} buddySlug={activeLearner?.buddy?.slug} />;
  }

  if (current.display_variant === 'toast') {
    return <CompactToast progression={current} onDismiss={dismiss} />;
  }

  // display_variant 'inline' handled by BP-DELIGHT-03 (micro feedback)
  // display_variant 'none' — nothing to render
  return null;
}
